// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"60":"de6265e4","242":"fbbe8a98","289":"aa96b3b1","317":"aed7f0cc","326":"c5bda9d1","369":"5411e68b","418":"e50627b4","440":"6a7696b3","510":"0de93a3f","522":"8a2a4cae","796":"90411021"}[chunkId] + ".js";
};